import styled, { css } from 'styled-components';
import _Section from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/Section';
import _YoutubeIframe from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/LearnImmerseCommunicate/LearnImmerse/YoutubeIframe';
import BackgroundDesktop from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/LearnImmerseCommunicate/images/background-red.png';

export const Section = styled(_Section)(
  ({ theme }) => css`
    display: none;

    @media (min-width: 1152px) {
      display: flex;
      background-image: url(${BackgroundDesktop});
      background-size: 1440px 1800px;
      padding-top: ${theme.sz.s10};
      padding-bottom: ${theme.sz.s10};
      background-color: ${theme.co.neutral0};
      background-position-x: center;
      background-position-y: top;
      background-repeat: no-repeat;
    }
  `,
);

export const SectionContent = styled(_Section.Content)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.sz.s6};
  `,
);

export const YoutubeIframe = styled(_YoutubeIframe)(
  () => css`
    width: 100%;
  `,
);
